import React from "react"

import AuthContextProvider from "./src/context/AuthContext"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LoadingContextProvider from "./src/context/LoadingContext"
import BreadcrumbsContextProvider from "./src/context/BreadcrumbsContext"
import MenuContextProvider from "./src/context/MenuContext"
import Layout, { LayoutSSR } from "./src/components/Layout"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { ilerlemeBitir, navigateSar } from "./src/utils/ilerlemeCubugu"
import { kanalTiklamalariniDinle } from "./src/utils/olcum"



export const wrapRootElement = ({ element }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
    <BreadcrumbsContextProvider>
      
        <MenuContextProvider>
          <AuthContextProvider>

            {element}

          </AuthContextProvider>
        </MenuContextProvider>
      
    </BreadcrumbsContextProvider>
  </LocalizationProvider>

)


// Client da yani browserda compoenntleri sarıyor

export const wrapPageElement = ({ element }) => {
  return <LoadingContextProvider><LayoutSSR>{element}</LayoutSSR></LoadingContextProvider>;
};


// Sayfa gecislerinde ustte ince ilerleme cubugu: tiklama aninda baslar, yeni sayfa cizilince biter
export const onInitialClientRender = () => {
  navigateSar();
  kanalTiklamalariniDinle();
};

export const onRouteUpdate = () => {
  ilerlemeBitir();
};
